<!-- eslint-disable vue/no-mutating-props -->
<template>
	<div class="mdc-form-field ln-form-field ln-form-field--checkbox">
		<div class="mdc-checkbox" v-if="Array.isArray(step.value)">
			<input
				class="mdc-checkbox__native-control"
				type="checkbox"
				v-bind:name="step.name"
				v-bind:id="`${step.name}-${option.value}`"
				v-bind:value="option.value"
				v-model="step.value"
			/>
			<div class="mdc-checkbox__background">
				<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
					<path
						class="mdc-checkbox__checkmark-path"
						d="M1.73,12.91 8.1,19.28 22.79,4.59"
						fill="none"
					/>
				</svg>
				<div class="mdc-checkbox__mixedmark"></div>
			</div>
		</div>
		<div class="mdc-radio" v-else>
			<input
				class="mdc-radio__native-control"
				type="radio"
				v-bind:name="step.name"
				v-bind:id="`${step.name}-${option.value}`"
				v-bind:value="option.value"
				v-model="step.value"
			/>
			<div class="mdc-radio__background">
				<div class="mdc-radio__outer-circle"></div>
				<div class="mdc-radio__inner-circle"></div>
			</div>
		</div>
		<label v-bind:for="`${step.name}-${option.value}`">
			{{ option.label[locale] }}
		</label>
	</div>
</template>

<script>
export default {
	name: 'Input',
	props: {
		step: Object,
		option: Object,
		locale: {
			type: String,
			default: 'de'
		}
	},
	mounted() {
		if (window.LN && window.LN.initCustomFields) {
			window.LN.initCustomFields(this.$el);
		}
	}
};
</script>
